import { Controller } from "@hotwired/stimulus"
import {
  CASE_CARD_MODAL_LIST_BULLET_CLASS,
  CASE_CARD_MODAL_LIST_ITEM_CLASS,
  CASE_CARD_MODAL_LIST_TEXT_CLASS
} from "./case_card_modal_classes"

export default class extends Controller {
  static targets = ["subtitle", "intro", "list", "modal"]

  open(event) {
    event.preventDefault()

    const params = event.params
    this.subtitleTarget.textContent = params.title || ""
    this.listTarget.innerHTML = this.renderObjectives(
      this.parseArrayParam(params.learningObjectives),
      params.searchText || ""
    )

    this.syncDialogDescription()
    this.modalController.show(event)
  }

  get modalController() {
    return this.application.getControllerForElementAndIdentifier(this.modalTarget, "railsui-modal")
  }

  parseArrayParam(value) {
    if (Array.isArray(value)) return value
    if (value == null || value === "") return []

    try {
      const parsed = JSON.parse(value)
      return Array.isArray(parsed) ? parsed : []
    } catch (_error) {
      return []
    }
  }

  renderObjectives(objectives, searchText) {
    return objectives
      .map((objective) => {
        return `
          <li class="${CASE_CARD_MODAL_LIST_ITEM_CLASS}">
            <span class="${CASE_CARD_MODAL_LIST_BULLET_CLASS}" aria-hidden="true"></span>
            <span class="${CASE_CARD_MODAL_LIST_TEXT_CLASS}">${this.renderObjectiveText(objective, searchText)}</span>
          </li>
        `
      })
      .join("")
  }

  renderObjectiveText(objective, searchText) {
    const text = String(objective)

    if (!searchText) {
      return this.escapeHtml(text)
    }

    const normalizedSearch = searchText.toLowerCase()
    if (!text.toLowerCase().includes(normalizedSearch)) {
      return this.escapeHtml(text)
    }

    const regex = new RegExp(this.escapeRegExp(searchText), "gi")
    let lastIndex = 0
    let result = ""
    let match = regex.exec(text)

    while (match !== null) {
      result += this.escapeHtml(text.slice(lastIndex, match.index))
      result += `<span class="search-hit">${this.escapeHtml(match[0])}</span>`
      lastIndex = match.index + match[0].length
      match = regex.exec(text)
    }

    result += this.escapeHtml(text.slice(lastIndex))
    return result
  }

  syncDialogDescription() {
    const container = this.modalTarget.querySelector("[data-railsui-modal-target='container']")
    if (!container) return

    const describedby = [
      this.subtitleTarget.id,
      this.hasIntroTarget ? this.introTarget.id : null,
      this.listTarget.id
    ]
      .filter(Boolean)
      .join(" ")
    if (describedby) {
      container.setAttribute("aria-describedby", describedby)
    }
  }

  escapeHtml(value) {
    return String(value)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#39;")
  }

  escapeRegExp(value) {
    return String(value).replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
  }
}
